import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";

/**
 * NotaTipoField - Expense/Income radio toggle for the note create/edit forms.
 * Backed by real radio inputs (name="tipo") for accessibility; "Expense" is
 * the default selection, matching the model's default tipo value.
 */
const NotaTipoField = ({ value, onChange }) => {
  const isEntrata = value === "entrata";

  return (
    <div className="nota-tipo-toggle" role="radiogroup" aria-label="Note type">
      <label
        className={`nota-tipo-option ${!isEntrata ? "nota-tipo-option--active nota-tipo-option--spesa" : ""}`}
      >
        <input
          type="radio"
          name="tipo"
          value="spesa"
          checked={!isEntrata}
          onChange={() => onChange("spesa")}
        />
        <FaMinusCircle size={13} />
        Expense
      </label>
      <label
        className={`nota-tipo-option ${isEntrata ? "nota-tipo-option--active nota-tipo-option--entrata" : ""}`}
      >
        <input
          type="radio"
          name="tipo"
          value="entrata"
          checked={isEntrata}
          onChange={() => onChange("entrata")}
        />
        <FaPlusCircle size={13} />
        Income
      </label>
    </div>
  );
};

export default NotaTipoField;
